import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Spinner } from '../ui/spinner';
import { useEffect, useState } from 'react';
import { useToast } from '../ui/use-toast';
import { Requester } from '@/lib/Requester';
import { MasterpassTokenResponse } from '@/models/Order';
import { GenericResponse } from '@/models/GenericResponse';
import { Endpoints } from '@/lib/Endpoints';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../ui/input-otp';
import Image from 'next/image';
import SmartImage from '../SmartImage';
import { set } from 'date-fns';

export default function MasterpassOTPDialog({
  open,
  onOpenChange,
  verifyingOTP,
  setVerifyingOTP,
  mfsResponseHandler,
  vCount,
  setPaying,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  verifyingOTP: boolean;
  setVerifyingOTP: (open: boolean) => void;
  mfsResponseHandler: (status, response) => void;
  vCount: number;
  setPaying: (paying: boolean) => void;
}) {
  const { toast } = useToast();

  const [code, setCode] = useState('');

  useEffect(() => {
    setCode('');
  }, [open, vCount]);

  const aError = () => {
    toast({
      variant: 'destructive',
      description: 'Bir hata oluştu',
    });
  };

  const verifyOTP = async () => {
    setPaying(true);
    if (verifyingOTP) {
      return;
    }
    if (!window?.Masterpass) {
      aError();
      return;
    }
    setVerifyingOTP(true);
    const { data: result } = await Requester.get<GenericResponse<MasterpassTokenResponse>>(
      Endpoints.MASTERPASS_GET_TOKEN,
    );
    if (!result?.data?.accessToken || !result?.data?.serviceUrl) {
      aError();
      return;
    }
    const serviceData = result?.data;
    window.Masterpass.setEndpoint(serviceData.serviceUrl);
    window.Masterpass.setToken(serviceData.accessToken);
    const tokenData = window.Utils.decodeJwt(serviceData.accessToken);
    window.Masterpass.setMerchantId(tokenData.MerchantId);
    const paylod = {
      otpCode: code,
    };
    window.Masterpass.verifyService.verifyOtp(paylod, mfsResponseHandler);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="space-y-0">
          <div className="mb-5 text-center">
            <SmartImage
              className="inline"
              src="/masterpass.svg"
              alt="masterpass by mastercard"
              width={149}
              height={32}
              imageType="custom"
            />
          </div>
          <DialogTitle className="text-[32px] text-hzc_purple_500">Kart doğrulama</DialogTitle>
          <DialogDescription className="h-0"></DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <div className="text-start text-sm text-hzc_beige_900">
            Banka tarafından kart sahibine gönderilen tek seferlik doğrulama kodunu giriniz.
          </div>
          <InputOTP
            maxLength={6}
            value={code}
            onChange={(value) => setCode(value)}
            key={`inputOTP_${vCount}`}
          >
            <InputOTPGroup className="mx-auto">
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>
        <DialogFooter className="gap-2">
          <div className="flex flex-row gap-4 justify-end">
            <Button
              className="text-hzc_beige_900 border-1 border-[#5E6AFF1A] bg-[#FFFFFF] hover:bg-[#FFFFFF] transition-all duration-300 hover:scale-105 rounded-full h-[48px]"
              onClick={() => {
                setPaying(false);
                onOpenChange(false);
              }}
            >
              Kapat
            </Button>
            <Button
              className="text-hzc_purple_500 bg-[#5E6AFF1A] hover:bg-[#5E6AFF1A] transition-all duration-300 hover:scale-105 rounded-full h-[48px] gap-2"
              onClick={() => verifyOTP()}
            >
              {verifyingOTP && <Spinner className="size-6 text-white" />}
              Onayla
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
